import CreatedDate from './CreatedDate';
import ConfirmedDate from './ConfirmedDate';
import Courier from './Courier';
import SavedFilter from './SavedFilter';
import Status from './Status';
import Tags from './Tags';

export default {
    CreatedDate,
    ConfirmedDate,
    Courier,
    SavedFilter,
    Status,
    Tags
}